import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@mui/material";
import {useState} from "react";

export const Feedback = ({feedback, setFeedback, setFeedbackSent}) => {
    const [feedbackLoading, setFeedbackLoading] = useState(false);
    const [feedbackText, setFeedbackText] = useState("");
    return (
        <Dialog className={"ItemViewPaper"} open={feedback} onClose={() => setFeedback(false)}>
            <DialogTitle>
                Feedback
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Have some suggestions or found a bug? Send us feedback here.
                    <br/>
                    All feedback is anonymous.
                </DialogContentText>
                <br/>
                <TextField disabled={feedbackLoading} value={feedbackText}
                           onChange={(event) => {
                               setFeedbackText(event.target.value);
                           }} autoFocus placeholder={"Enter feedback here"} sx={{width: "100%"}} minRows={4} multiline/>
            </DialogContent>
            <DialogActions>
                <Button disabled={!feedbackText || feedbackLoading || feedbackText?.length < 3} onClick={async () => {
                    setFeedbackLoading(true);
                    try {
                        const response = await fetch(`/feedback?body=${feedbackText}`, {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            }
                        });
                        if (response.ok) {
                            setTimeout(() => {
                                setFeedback(false);
                                setFeedbackSent(true);
                                setTimeout(() => {
                                    setFeedbackText("");
                                    setFeedbackLoading(false);
                                }, 500);
                            }, 1000);
                        }
                    } catch {
                    }
                }}>
                    {feedbackLoading ? <CircularProgress size={16} thickness={4} sx={{
                        width: "64px"
                    }}/> : "Send"}
                </Button>
                <Button disabled={feedbackLoading} onClick={() => {
                    setFeedback(false);
                    setFeedbackText('')
                }}>Cancel</Button>
            </DialogActions>
        </Dialog>
    )
}